import { type FunctionalComponent, h } from '@stencil/core';
import {imagePlaceholder} from '../../../../../variables';

interface IDashboardProductsSkeleton {
  picturePlaceholder?: boolean;
  blocks: number;
}

export const DashboardProductsSkeleton: FunctionalComponent<IDashboardProductsSkeleton> = ({ picturePlaceholder, blocks }) => (
  <div class="dashboard-products-skeleton-container">
    <div class="dashboard-products-skeleton">
      {Array.from({ length: blocks }).map((_, index) => (
        <div class="products-skeleton-item">
          {picturePlaceholder && <img
            class="product-skeleton-image"
            src={imagePlaceholder}
            width={100}
            height={100}
            alt="image placeholder"
          />}
          <div class="search-skeleton">
            <div class="search-skeleton__item"></div>
            <div class="search-skeleton__item"></div>
            <div class="search-skeleton__item"></div>
            <div class="search-skeleton__item"></div>
          </div>
        </div>
      ))}
    </div>
  </div>
);
